export default __webpack_public_path__ + "static/media/icon-wallet.53beb7e8.svg";